import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AutoImage } from '../components/auto-image'
import { BannerImage } from '../components/banner-image'
import { BlogSection } from '../components/blog-section'
import { ContentContainer } from '../components/content-container'
import { DecoratedFrame } from '../components/decorated-frame'
import { HeadBannar } from '../components/head-bannar'
import { Section } from '../components/section'
import { SectionNavigator } from '../components/section-navigator'
import { SectionSpaceLarge, SectionSpaceMedium } from '../components/section-space'
import { SectionTextExtraLarge, SectionTextMedium, SectionTextSmall } from '../components/section-text'
import { SectionTitle } from '../components/section-title'
import { DiagramContainer, DiagramItem, ItemTitle, ItemText } from '../components/section-diagram'
import { Mbr } from '../components/br'

const Outer = styled.div``

type MuronokiPageProps = {

}
export const MuronokiPage: FunctionComponent<MuronokiPageProps> = () => {
  return <Outer>
    <HeadBannar desktop={() => <BannerImage src="/images/header_02.jpg" />} mobile={() => <BannerImage src="/images/header_02_mobile.jpg" />}></HeadBannar>
    <ContentContainer>
      {/* <SectionNavigator labelMap={new Map([['about', 'About us'], ['diagram', '概念図']])} /> */}
      <Section id="about">
        <SectionTitle>About us</SectionTitle>
        <SectionSpaceMedium />
        <DecoratedFrame leftTop="/images/dec_02_01.png" rightBottom="/images/dec_02_02.png">
          <AutoImage src="/images/img_02.jpg" mobileSrc="/images/img_02_mobile.jpg" />
          <AutoImage src="/images/img_03.jpg" mobileSrc="/images/img_03_mobile.jpg" />
        </DecoratedFrame>
        <SectionSpaceMedium />
        <SectionTextSmall>
          室の木幼稚園では、少子化に伴う教育・保育行政の変化のスピードが早い時代においても、<br />
          1号・2号といった支給認定に関わらず、<br />
          満3歳から5歳の子どもたちが等しく教育を受けられる環境整備に努めています。<br />
          「恵まれた自然環境の中で健康な体と豊かな心を育てる」<br />
          「たくさんの体験を通して、やり遂げる力、考える力を培う」<br />
          「のびのびと遊ぶ中で豊かな人間関係を育む」<br />
          この3つの教育方針を掲げ、子ども達の健全な成長を導いています。
        </SectionTextSmall>
      </Section>
      <Section id="diagram">
        <DiagramContainer>
          <DiagramItem>
            <ItemTitle>1号認定とは</ItemTitle>
            <ItemText>
              1号認定とは、満３歳以上で“保育の必要性がない（教育を受けさせることを希望する）子どもたち”を指します。保育の必要性は、保護者の就労状況などによって決まります。<br />
              教育時間は基本的に10:00-14:00となっていますが、当園は横浜市認定預かり保育幼稚園となっていますので、預かり保育（ワンツーキッズポケット）を利用して、朝7:30～保育終了後の18:30までご利用いただけます。
            </ItemText>
          </DiagramItem>
          <DiagramItem>
            <ItemTitle>2号認定とは</ItemTitle>
            <ItemText>
              2号認定とは、3歳児以上で保育の必要性がある子どもたちを指します。両親が共働きであったり、妊娠・出産で保育が必要という場合に横浜市に申請して2号認定を受けることができます。<br />
              保育の必要性の程度は、ご家庭の状況によって変わり、保育短時間認定（8時間）と保育標準時間認定（11時間）があります。延長保育もありますので、開園時間の範囲で認定された時間を超えた利用も可能です。
            </ItemText>
          </DiagramItem>
        </DiagramContainer>
      </Section>
      <BlogSection where={{categoryName: 'muronoki'}}/>
    </ContentContainer>
  </Outer>
}